import * as React from "react";
import { forwardRef } from "react";
const SvgReorderIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 12 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.33398 5.72624L10.6673 5.72624M7.33398 11.7262L6.00065 13.0596L4.66732 11.7262M7.33398 2.3929L6.00065 1.05957L4.66732 2.3929M1.33398 8.3929L10.6673 8.3929", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgReorderIcon);
export { ForwardRef as ReactComponent };
